import { useHistory } from 'react-router-dom';
import CryptoJS from 'crypto-js';


const useDecryptedAuth = () => {
    const history = useHistory();
    
    try {
        const bytes = CryptoJS.AES.decrypt(localStorage.getItem("authAdmin"), process.env.REACT_APP_ADMIN_TOKEN_SECRET);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        console.error('Error decrypting authAdmin : ', error.message);
        history.push('/logout', { code: 401, status: 'error', message: 'Access token expired or mismatched due to changes in admin authentication session!' });
        return null;
    }
};


export default useDecryptedAuth;